<!--
 * @Description: (弹框)申请分账组件
 * @Author: wanqian, gaohc
 * @Date: 2023-10-16 08:43:52
-->
<template>
  <el-dialog width="965px" center title="申请分账" :visible.sync="visible" :close-on-click-modal="false"
    @open="initData" :before-close="handleCancel" append-to-body>
    <div class="apply-sharing-dialog">
      <div class="bk-head">
        <el-row :gutter="10" type="flex" justify="space-between" align="center">
          <el-col :span="24">
            <div style="display: flex; align-items: center; justify-content: flex-end;" class="mouse-pointer" 
              @click="handleOrderDetailsClick">
              <img style="width: 18px; height: 19px;" src="@/assets/finance/sharinglist/icon-sharinglist-order.png" 
                alt="" />
              <div style="margin: 0 4px; font-size: 14px; color: #3A7FF3;">订单与排班详情</div>
              <img style="width: 8px; height: 13px;" src="@/assets/finance/sharinglist/icon-sharinglist-arrow-right-blue.png" 
                alt="" />
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="bk-money">
        <div>
          <div class="sharing-total-money">{{'应分总额 ：' + sharingDTO.sharableAmountYuan}}</div>
          <div class="order-money">
            <div>{{'实付 ：' + sharingDTO.payAmountYuan}}</div>
            <div v-if="1" style="display: flex; align-items: center;">
              <div class="div-vline"></div>
              <div>{{'提前结束退款 ：' + sharingDTO.refundAmountYuan}}</div>
            </div>
          </div>
        </div>
        <img class="img-status" src="@/assets/finance/sharinglist/img-finance-sharinglist-wait-apply.png" alt="">
      </div>
      <el-table style="margin-top: 16px;" border ref="table" :data="dataTable" 
        header-cell-class-name="table-header-color" row-key="id" :span-method="objectSpanMethod">
        <el-table-column label="类型" min-width="11%" align="center">
          <template slot-scope="scope">{{scope.row.ownerTypeText}}</template>
        </el-table-column>
        <el-table-column label="比例" min-width="11%" align="center">
          <template slot-scope="scope">
          <span v-if="scope.row.ownerType == 11">
            {{getSumByKeyUsingForEach(11, 'ratioStr') + '%'}}
          </span>
          <span v-else>
            {{scope.row.ratioStr + '%'}}
          </span>
        </template>
        </el-table-column>
        <el-table-column label="收款方" min-width="16%" align="center">
          <template slot-scope="scope">{{scope.row.owner}}</template>
        </el-table-column>
        <el-table-column label="应分金额（元）" min-width="15%" align="center">
          <template slot-scope="scope">{{scope.row.sharableTotalAmountYuan}}</template>
        </el-table-column>
        <el-table-column label="扣款/补贴（元）" min-width="16%" align="center">
          <template slot-scope="scope">
            <span>{{getDedtAmountYuan(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="实分金额（元）" min-width="16%" align="center">
          <template slot-scope="scope">
            <!-- 只有派单人、服务人和其他能修改实分金额 -->
            <el-popover v-if="scope.row.ownerType == 10 || scope.row.ownerType == 11 
              || scope.row.ownerType == 20" placement="bottom" width="254" 
              :ref="'moneyEditPopover' + scope.$index">
              <div slot="reference" class="mouse-pointer">
                <div style="display: flex; align-items: center; justify-content: center;">
                  <div>{{scope.row.editMoney ? scope.row.editAmountYuan 
                    : scope.row.sharingTotalAmountYuan}}
                  </div>
                  <img style="margin-left: 12px; width: 15px; height: 15px;" 
                    src="@/assets/finance/sharinglist/icon-sharinglist-edit.png" alt="" />
                </div>
              </div>
              <div style="padding: 8px 18px; text-align: center;" class="bk-edit-money">
                <div style="font-size: 14px; color: #303133;">修改金额</div>
                <el-input style="margin-top: 19px;" placeholder="" v-model="scope.row.editAmountYuan" 
                  maxlength="10" @input="inputEditMoney(scope)">
                </el-input>
                <div style="margin-top: 20px; display: flex; align-items: center; justify-content: center;">
                  <el-button size="mini" @click="handleCancelEditMoney(scope)">取 消</el-button>
                  <el-button type="primary" size="mini" @click="handleSaveEditMoney(scope)">保 存</el-button>
                </div>
              </div>
            </el-popover>
            <div v-else-if="scope.row.ownerType == 2" style="display: flex; align-items: center; justify-content: center;">
              <div>{{instSharingAmount(scope.row)}}</div>
              <!-- 对齐占位视图 -->
              <div style="margin-left: 12px; width: 15px; height: 15px;"></div>
            </div>
            <div v-else style="display: flex; align-items: center; justify-content: center;">
              <div v-if="hasInst">{{scope.row.sharingTotalAmountYuan}}</div>
              <div v-else>{{instSharingAmount(scope.row)}}</div>
              <!-- 对齐占位视图 -->
              <div style="margin-left: 12px; width: 15px; height: 15px;"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分账到" min-width="15%" align="center">
          <template slot-scope="scope">{{scope.row.accountTypeText}}</template>
        </el-table-column>
      </el-table>
      <div class="div-notes">
        <el-input type="textarea" :rows="3" placeholder="请输入备注信息" v-model="notes" maxlength="200"></el-input>
      </div>
      <div class="dialog-footer bk-wizard-bottons">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirmSharing">申请分账</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Constant from '@/global/Constant.js'
import Util from '@/global/Util.js'

export default {
  name: 'SharingDetails',

  props: ["visible", 'orderId', "sharingId"],

  data() {
    return {
      sharingDTO: {},
      dataTable: [],
      isUpdate: false,
      servicerTotalAmount: 0,    //服务人应分总金额
      notes: '',

      servicerPosition: {startIndex: 0, length: 0},

      hasInst: false,

      calculated: false
    }
  },

  computed: {
    status() {
      if (this.sharingDTO.hasOwnProperty('revenueSharing') 
        && this.sharingDTO.revenueSharing.hasOwnProperty('status')) {
          return this.sharingDTO.revenueSharing.status;
      }
      return '';
    },

    instSharingAmount() {
      return (row)=> {
        if (this.calculated) return row.sharingTotalAmountYuan;
        let deductionPerkAmountYuan = this.getInstPerkAmount();
        return (parseFloat(row.sharingTotalAmountYuan) + 
          parseFloat(deductionPerkAmountYuan)).toFixed(2);
      }
    },

    getDedtAmountYuan() {
      return (row)=> {
        if (row.ownerType == 1 && this.hasInst) {
          return row.deductionPerkAmountYuan != 0 ? '服务回款：+' + row.deductionPerkAmountYuan : 0; 
        } else if ((row.ownerType == 2 && this.hasInst) || (row.ownerType == 1 && !this.hasInst)) {
          if (this.getInstPerkAmount() == 0) return 0;
          return this.getInstPerkAmount() > 0 ? '服务回款：+'+ this.getInstPerkAmount() : this.getInstPerkAmount();
        } else if (row.ownerType == 10 || row.ownerType == 20) {
          let diffAmount = parseFloat(this.getDispatchDedtAmount(row)).toFixed(2);
          if (diffAmount == 0) return 0;
          return  diffAmount > 0 ? "服务补贴：" + Number(diffAmount) : "服务扣款：" + Number(diffAmount);
        } else if (row.ownerType == 11) {
          return this.getServicerOrOtherDedtAmount(11);
        }
      }
    }
  },
  
  methods:{
    initData() {
      let params = {id: this.sharingId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_REVENUE_SHARING_DETAILS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
     	this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.sharingDTO = result.data;
          this.dataTable = result.data.revenueSharingItemList;
          this.rebuildTableData();
          this.hasInst = this.dataTable.some(item => item.ownerType === 2);
          this.getFlagObjPosition("servicerPosition");
        }
      })
    },

    rebuildTableData() {
      this.servicerTotalAmount = 0;
      this.dataTable.forEach(item => {
        this.$set(item, 'editMoney', false);
        this.$set(item, 'editAmountYuan', '');
        if (item.ownerType == 11) {
          this.servicerTotalAmount += parseFloat(item.sharableTotalAmountYuan) || 0;
        }
      });
    },

    //获取机构补贴/扣款金额
    getSumByKeyUsingForEach(val, key) {
      let sum = 0;
      this.dataTable.forEach(obj => {
         if (obj.ownerType == val) {
          sum += parseFloat(obj[key]) || 0;
         }
      });

      return Number(sum);
    },

    //获取派单人扣款金额
    getDispatchDedtAmount(row) {
      if (!row.editMoney) return row.deductionPerkAmountYuan != 0 
        ? row.deductionPerkAmountYuan : 0;
      return Number(row.editAmountYuan) - Number(row.sharableTotalAmountYuan); 
    },

    //获取机构补贴金额
    getInstPerkAmount() {
      let perkAmount = 0;
			this.dataTable.forEach((item, _i) => {
        if (!(item.ownerType == 10 || item.ownerType == 11 || item.ownerType == 20)) return
        if (item.editMoney) {
          let diffAmount = Math.abs(item.sharableTotalAmountYuan) - Math.abs(item.editAmountYuan)     
          perkAmount += diffAmount
        } else {
          perkAmount += Math.abs(item.deductionPerkAmountYuan);
        }
			});

      return perkAmount.toFixed(2);
    },

    //获取服务人/其他人扣款金额
    getServicerOrOtherDedtAmount(ownerType) {
      let dedtAmount = 0;
			this.dataTable.forEach((item, _i) => {
        if (item.ownerType != ownerType) return
        if (item.editMoney) {
          let diffAmount = Number(item.editAmountYuan) - Number(item.sharableTotalAmountYuan);     
          dedtAmount += diffAmount
        } else {
          dedtAmount += Number(item.deductionPerkAmountYuan);
        }
			});
      if (dedtAmount == 0 || Number(dedtAmount).toFixed(2) == 0) return '0';
      return dedtAmount > 0 ? "服务补贴：" + Number(dedtAmount).toFixed(2) : "服务扣款：" + Number(dedtAmount).toFixed(2); 
    },

    // 获取详情集合中收款方类型是其他人的信息，包括起始下标，以及长度
    getFlagObjPosition(flagObj) {
      let startIndex = -1;
      let totalLength = 0;
      this.dataTable.forEach((item, index) => {
        // 收款方类型：1-本平台 2-机构 3-代理 10-派单人 11-服务人 20-其他人
				if (item.ownerType == (flagObj == 'servicerPosition' ? 11 : 20)) {
          if (startIndex == -1) { startIndex = index; }
          totalLength += 1;
        }
			})
      this[flagObj] = {'startIndex': startIndex, 'length': totalLength};
    },

    handleOrderDetailsClick() {
      this.$emit('check-order-detail', this.orderId);
    },

    handleCancelEditMoney(scope) {
      this.$refs['moneyEditPopover' + scope.$index].doClose();
    },

    handleSaveEditMoney(scope) {
      scope.row.editMoney = true;
      scope.row.deductionPerkAmountYuan = Number(scope.row.editAmountYuan) - Number(scope.row.sharableTotalAmountYuan);
      this.dataTable.splice(scope.$index, 1, scope.row);
      this.isUpdate = true;
      this.changeNotes();
      this.$refs['moneyEditPopover' + scope.$index].doClose();
    },

    inputEditMoney(scope) {
      scope.row.editAmountYuan =  Util.limitInputTwoDecimal(this.commonUtil.filterDigitals(
        scope.row.editAmountYuan, ['.']));
    },

    vaildEditServicerWithIndex() {
			let servicerTotalMoney = 0;
			this.dataTable.forEach((item) => {
        if (item.ownerType != 11) return
        if (item.editMoney) {
          servicerTotalMoney += Number(item.editAmountYuan);
        } else {
          servicerTotalMoney += Number(item.sharableTotalAmountYuan);
        }
			});
			return servicerTotalMoney <= this.servicerTotalAmount;
    },

    vaildInputEmpty() {
      let arr = this.dataTable.filter(item => 
        ((item.editMoney && item.editAmountYuan) || (!item.editMoney && item.sharingTotalAmountYuan))
      );
      return arr.length == this.dataTable.length;
    },

    vaildTotalInputMoney() {
			let totalMoney = 0
			this.dataTable.forEach((item) => {
        if (item.editMoney) {
          totalMoney += Number(item.editAmountYuan);
        } else {
          totalMoney += Number(item.sharingTotalAmountYuan);
        }
			});
			return totalMoney <= this.sharingDTO.sharableAmountYuan;
		},

    changeNotes() {
			let arr = this.dataTable.filter(item => 
        item.editMoney
      ).map(obj=> {
        let diffAmount = Number(obj.sharableTotalAmountYuan) - Number(obj.editAmountYuan);
        if (!diffAmount) return;
        return obj.owner + '应分' + obj.sharableTotalAmountYuan + '元，' + (diffAmount > 0 ? '扣款' : '补贴')
          + Math.abs(diffAmount).toFixed(2) + '元'
      });
      let list = arr.filter(current => {
        return current != null && current != undefined
      })
      this.notes = list.join('\n');
    },

    handleCancel() {
      this.clearForm();
      this.$emit("close-dialog", false);
    },

    handleConfirmSharing() {
      // 1、金额>=0
			// 2、输入项总金额<=订单应分总额*各类型对应百分比
			// 3、实分金额列所有相加等于应分总额

      if (!this.vaildInputEmpty()) {
        this.$message.error('请输入金额');
        return;
      }

      if (!this.vaildEditServicerWithIndex()) {
        this.$message.error('服务人实分金额列所有相加小于等于服务人应分总额');
				return;
      }

      if (!this.vaildTotalInputMoney()) {
        this.$message.error('实分金额列所有相加小于等于应分总额');
				return;
			}

      this.handlePostSharingData();
    },

    handlePostSharingData() {
      let requestParam = {
        revenueSharingId: this.sharingId,
        remark: this.notes,
        update: this.isUpdate
      }
      requestParam.revenueSharingItemList = this.rebuildPostParam();
      let header = this.encryptionUtil.signatureBody(requestParam,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'PUT',
        url: Constant.URL_APPLY_REVENUE_SHARING,
        param: requestParam,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.clearForm();
          this.$emit("close-dialog", true, result.data);  
        }
      })
    },

    //重组提交的参数
    rebuildPostParam() {
      let _this = this;
      let type = _this.hasInst ? 2 : 1;
      _this.calculated = false;
      this.dataTable.forEach((item)=> {
        if (item.ownerType == type) {
          item.deductionPerkAmountYuan = _this.getInstPerkAmount();
          item.sharingTotalAmountYuan = (parseFloat(item.sharingTotalAmountYuan) + 
          parseFloat(item.deductionPerkAmountYuan)).toFixed(2);
          _this.calculated = true;
        }
        if (item.editMoney) item.sharingTotalAmountYuan = item.editAmountYuan;
        delete item.editMoney;
        delete item.editAmountYuan;
      })
      return this.dataTable;
    },

    clearForm() {
      this.notes = '';
      this.sharingDTO = {};
      this.dataTable = [];
      this.servicerPosition = {startIndex: 0, length: 0};
      this.othersPosition = {startIndex: 0, length: 0};
      this.calculated = false;
    },

    // 合并行或列
    objectSpanMethod({_row, _column, rowIndex, columnIndex}) {
      // 合并第一列、第二列、第五列类型为其他人的行，如果没有其他人类型/其他列则返回
      if ((columnIndex != 0 && columnIndex != 1 && columnIndex != 4) || !this.servicerPosition.length) return;
      // 1代表单独占一行，更大的自然数代表合并了若干行，0代表“消失”的哪那一个单元格，后面的单元格向前推一格
      if (rowIndex == this.servicerPosition.startIndex) {
        return [this.servicerPosition.length, 1];
      } else if (rowIndex > this.servicerPosition.startIndex 
        && rowIndex < (this.servicerPosition.startIndex + this.servicerPosition.length)) {
        return [0, 1];
      } else {
        return [1, 1];
      }
    },

    dateFormat(date) {
      return this.dateUtil.dateTimeFormat(date, "YYYY-MM-DD HH:mm");
    }
  },
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
.apply-sharing-dialog {
  padding: 0 25px;
}
.bk-head {
  padding: 26px 30px;
  background-color: #F7F9FE;
}
.bk-head .text {
  font-size: 14px;
  color: #525254;
  line-height: 19px;
}
.bk-head .text-blue {
  color: #3E7EF5;
}
.bk-money {
  position: relative;
  margin-top: 16px;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
}
.bk-money .sharing-total-money {
  font-size: 15px;
  color: #333333;
  line-height: 20px;
}
.bk-money .order-money {
  margin-top: 14px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #606266;
  line-height: 19px;
}
.div-vline {
  margin: 0 20px;
  width: 1px;
  height: 15px;
  background-color: #D7DDE5;
}
.img-status {
  width: 100px;
  height: 100px;
  position: absolute;
  top: -30px;
  right: 34px;
}
.div-notes {
  margin-top: 20px;
}
.dialog-footer {
  margin-top: 40px;
  text-align: center;
}
</style>
<style>
.div-notes .el-textarea__inner {
  padding: 17px 22px !important;
  line-height: 1.3 !important;
}
.bk-edit-money .el-input__inner {
  height: 36px !important;
  line-height: 36px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/finance/components/sharinglist/ApplySharing.vue